import { FilterSection } from './FilterSection';
import { Filters } from '../../types/filters';

interface InvestmentStagesFilterProps {
    filters: Filters;
    onFiltersChange: (filters: Filters) => void;
    allStages: string[];
}

export function InvestmentStagesFilter({ filters, onFiltersChange, allStages }: InvestmentStagesFilterProps) {
    function handleCheckboxChange(value: string) {
        const currentValues = filters.investmentStages;
        const newValues = currentValues.includes(value)
            ? currentValues.filter(v => v !== value)
            : [...currentValues, value];

        onFiltersChange({ ...filters, investmentStages: newValues });
    }

    return (
        <FilterSection title="Investment Stages" defaultOpen={true}>
            <div className="space-y-1.5">
                {[...allStages].sort((a, b) => a.localeCompare(b)).map((stage) => (
                    <label key={stage} className="flex items-center group cursor-pointer">
                        <input
                            type="checkbox"
                            checked={filters.investmentStages.includes(stage)}
                            onChange={() => handleCheckboxChange(stage)}
                            className="w-4 h-4 rounded border-gray-300 text-indigo-500 focus:ring-indigo-500"
                        />
                        <span className="ml-2 text-sm text-gray-600 group-hover:text-gray-900">{stage}</span>
                    </label>
                ))}
            </div>
        </FilterSection>
    );
} 